import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Check .env.local.');
}

// We use the untyped client to avoid the strict generic constraints in
// @supabase/supabase-js. Result types are annotated at the call site via
// the Row types in database.types.ts.
export const supabase = createClient(url, anonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string) ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173');
